<div class="dialog-content-wrapper get-mail-dialog" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{dialogTitle}}</h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close(false)"
                [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <ng-container *ngIf="!data?.addresses?.length">
            <u2b-message type="warning">
                Keine E-Mail Adressen gefunden.
            </u2b-message>
        </ng-container>

        <ng-container *ngIf="data?.addresses?.length">
            <form [formGroup]="addressForm">
                <mat-selection-list formControlName="selectedAddresses">
                    <mat-list-option *ngFor="let address of data.addresses" [value]="address">
                        <span matListItemTitle class="get-mail-dialog__address" [textContent]="address"></span>
                    </mat-list-option>
                </mat-selection-list>
            </form>
        </ng-container>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

        <button data-test="B-Speichern" mat-flat-button (click)="save()" class="save-button mat-accent"
            [attr.aria-label]="'common.save' | translate" [disabled]=" isSaving || !addressForm.dirty">
            {{ 'common.save' | translate }}
        </button>

    </div>
</div>
